module.exports = __webpack_public_path__ + "static/media/talu.ad90abbb.png";